// import { createContext, useContext, useState, useEffect, useRef } from "react";

// const FooterVisibilityContext = createContext();

// export const FooterVisibilityProvider = ({ children }) => {
//     const [isFooterVisible, setIsFooterVisible] = useState(false);
//     const footerRef = useRef(null);

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => setIsFooterVisible(entry.isIntersecting),
//             { root: null, threshold: 0.01 } // Detect when 10% of footer is visible
//         );

//         if (footerRef.current) observer.observe(footerRef.current);

//         return () => {
//             if (footerRef.current) observer.unobserve(footerRef.current);
//         };
//     }, []);

//     return (
//         <FooterVisibilityContext.Provider value={{ isFooterVisible, footerRef }}>
//             {children}
//         </FooterVisibilityContext.Provider>
//     );
// };

// export const useFooterVisibility = () => useContext(FooterVisibilityContext);
import { createContext, useContext, useState, useEffect, useRef } from "react";

// Creating the context
const FooterVisibilityContext = createContext();

// Provider component to manage footer visibility state
export const FooterVisibilityProvider = ({ children }) => {
    const [isFooterVisible, setIsFooterVisible] = useState(false); // Track if footer is visible
    const [hasInitialized, setHasInitialized] = useState(false); // Flag to mark if observer has been initialized
    const[footeref,setFooterRef] = useState(null); // Ref to store the footer element
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                console.log("IntersectionObserver callback:", entry.isIntersecting); // Debug visibility change
                setIsFooterVisible(entry.isIntersecting); // Set visibility based on intersection
                if (!hasInitialized) {
                    setHasInitialized(true); // Mark as initialized after first intersection
                }
            },
            { root: null, threshold: 0.3 } // Trigger when at least 1% of footer is visible
        );

        if (footeref &&footeref.current) {
            observer.observe(footeref.current); // Observe footer visibility
        }

        return () => {
            if (footeref &&footeref.current) {
                observer.unobserve(footeref.current); // Cleanup observer on component unmount
            }
        };
    }, [footeref]); // Dependency on hasInitialized to avoid infinite loop

    return (
        <FooterVisibilityContext.Provider value={{setFooterRef, isFooterVisible, hasInitialized,setHasInitialized }}>
            {children}
        </FooterVisibilityContext.Provider>
    );
};

// Custom hook to use footer visibility context
export const useFooterVisibility = () => useContext(FooterVisibilityContext);
